import { useMemo } from "react";
import { Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { RichText } from "@constants/richText";
import { TableNode } from "@typings/richText";
import { nodeListToReactComponents } from "@utils/pageContent/richTextToJSX";
import * as Styled from "./RichTextTable.styled";

const RichTextTable: React.FC<TableNode> = ({ content }) => {
  const [headerRow, bodyRows] = useMemo(() => {
    const rows = [...content].map((row, index) => ({
      id: `row-${index}`,
      content: row.content.map((column, colIndex) => ({
        isHeader: column.nodeType === RichText.TABLE_HEADER_CELL,
        id: `column-${index}-${colIndex}`,
        children: nodeListToReactComponents(column.content),
      })),
    }));
    let headerRow;
    if (rows[0].content[0].isHeader) {
      headerRow = rows.shift();
    }
    return [headerRow, rows];
  }, [content]);

  return (
    <TableContainer>
      <MuiTable>
        {headerRow && (
          <TableHead>
            <TableRow>
              {headerRow.content.map((column) => (
                <Styled.TableHeaderCell key={column.id}>{column.children}</Styled.TableHeaderCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {bodyRows.map((row) => (
            <Styled.Row key={row.id}>
              {row.content.map((column) => (
                <TableCell key={column.id}>{column.children}</TableCell>
              ))}
            </Styled.Row>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};

export default RichTextTable;
